import { Navigate, Outlet } from 'react-router-dom'
function HomePage() {

    
    return (
        <>
           <Navigate to='/CompanySales' />
        </>
    )
}
export default HomePage
